import React from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/Overlay';
import { getTableHeader, IHeaderRows } from './helpers';
import { ICheckedTable, ICheckedCell } from 'components/models';
import styles from './CheckedTable.module.scss';
import _ from 'lodash';
import cn from 'classnames';

const CheckedTable = ({
    table, tableType, checkedCell, headersSeparator,
}: IProps) => {
    const headerArr = table.columns.map(col => col.header);
    const rowCount = checkedCell.length;
    const colCount = headerArr.length;

    const addSeparateRowToTable = (rows: JSX.Element[]) => {
        const newRows = rows.slice();

        if (checkedCell[rowCount - 1] && checkedCell[rowCount - 1][0].solution === 'total') {
            newRows.splice(rowCount - 1, 0, <tr key={_.uniqueId()}><td key={_.uniqueId()} colSpan={colCount} className={styles.empty_th} /></tr>);
        }
        return newRows;
    };

    const renderTableHeaders = (headers: IHeaderRows) => headers.map((h, i) => (
        <tr key={`${i}-r`}>
            {h.map((header, j) => <th key={j} colSpan={header.colSpan}>{header.text}</th>)}
        </tr>
    ));

    const renderTableItem = (rows: ICheckedCell[][]) => rows.map((row, i) => (
        <tr key={`${i}-r`}>
            {row.map((cell, j) => {
                if (i === rowCount - 1 && j === 0 && cell.solution === 'total') return <td key={j} colSpan={1}>ИТОГО:</td>;
                return (
                    <td
                      key={j}
                      className={cn(!cell.correct && (tableType && tableType === 'manual' ? [styles.incorrect_cell_manual] : [styles.incorrect_cell_auto]))}
                    >
                        {tooltipWrap(cell.standard || 'пустая ячейка', cell.solution || '')}
                    </td>
                );
            })}
        </tr>
    ));

    return (
        <>
            {table.caption && <span className={styles.caption}>{table.caption}</span>}
            <Table striped hover className={cn('taskTable', styles.checked_table)} data-test-table>
                <thead>
                    {renderTableHeaders(getTableHeader(headerArr, headersSeparator))}
                </thead>
                <tbody>
                    {table.rows
                        ? addSeparateRowToTable(renderTableItem(checkedCell))
                        : null}
                </tbody>
            </Table>
        </>
    );
};

const tooltipWrap = (text: string, element: React.ReactChild, placement: Placement = 'top') => (
    <OverlayTrigger
      key={placement}
      placement={placement}
      overlay={(
            <Tooltip className={placement} id={`tooltip-${placement}`}>
                {text}
            </Tooltip>
        )}
    >
        <div style={{ minHeight: '17px' }}>{element}</div>
    </OverlayTrigger>
);

export default CheckedTable;

interface IProps {
    table: ICheckedTable;
    checkedCell: ICheckedCell[][];
    headersSeparator: string;
    tableType?: 'manual' | 'autoCheck';
}
